
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { CompanyRef, Loan, LoanTransaction, ScheduleDate, Parameter, Contribution, PermanentSaving, ParameterDataLoader, PeriodTypeEnum } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { DataSourceService } from '../../../services/data-source.service';
import { UiService } from '../../../services/ui.service';
import { LogicService } from '../../../services/logic.service';
import { MatSnackBar } from '@angular/material';
import * as moment from 'moment';
import { MatSelectChange, MatDatepickerInputEvent } from '@angular/material';
import * as XlsxPopulate from 'xlsx-populate';
import { saveAs } from 'file-saver';
import { Helpers } from './../../../models/helpers';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-report-page',
  templateUrl: './report-page.component.html',
  styleUrls: ['./report-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportPageComponent implements OnInit, OnDestroy {

  format = 'DD-MMM-YYYY';
  tempSubCompany: CompanyRef | null = null;
  subCompanies: Array<CompanyRef> = Array<CompanyRef>();
  appModChangesSubscription: Subscription = null;
  reportDate = new ScheduleDate();
  employeeNumber: string;

  savingParameters: Array<Parameter> = new Array<Parameter>();
  parameterSubscription: Subscription;

  collectionByTypeHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'fecha', property: 'originalISODate' },
    { title: 'tipo', property: 'type' },
    { title: 'subtipo', property: 'subType' },
    { title: 'aportaciónEmpleado', property: 'employeeAmount' },
    { title: 'aportaciónEmpresa', property: 'companyAmount' },
    { title: 'retiroEmpleado', property: 'employeeWithdraw' },
    { title: 'retiroEmpresa', property: 'companyWithdraw' },
    { title: 'liquidaciónEmpleado', property: 'employeeSettlement' },
    { title: 'liquidaciónEmpresa', property: 'companySettlement' },
    { title: 'investmentReturn', property: 'investmentReturn' },
    { title: 'loanPerformance', property: 'loanPerformance' },
    { title: 'ID de compañía', property: 'companyID' },
    { title: 'contributionID', property: 'contributionID' }
  ];

  collectionBySuraHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'fecha', property: 'originalISODate' },
    { title: 'tipo', property: 'type' },
    { title: 'subtipo', property: 'subType' },
    { title: 'aportación', property: 'amount' }
  ];

  collectionByExtraHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber'},
    { title: 'año', property: 'year' },
    { title: 'fecha', property: 'date' },
    { title: 'tipo', property: 'bonusType' },
    { title: 'porcentajePrestamo', property: 'percentageLoan' },
    {title: 'tipoAportacion', property: 'type'}
  ];

  collectionSavingsHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'nombreColaborador', property: 'userName' },
    { title: 'fecha', property: 'subscriptionDate' },
    { title: 'tipoInversion', property: 'investmentType' },
    { title: 'numContrato', property: 'contractNumber' },
    { title: 'importeSolicitado', property: 'contributionAmount' },
    { title: 'numero de pagos', property: 'numberOfPayments' },
    { title: 'pago', property: 'payment' },
    { title: 'estatus', property: 'status' }
  ];

  employeeHeader: Array<any> = [
    { title: 'colaborador', property: 'workInformation.employeeNumber' },
    { title: 'Nombres', property: 'firstName' },
    { title: 'Primer Apellido', property: 'firstLastName' },
    { title: 'Segundo Apellido', property: 'secondLastName' },
    { title: 'Ultima modificación', property: 'modificationDate' },
    { title: 'idLegal', property: 'taxationIdentificationNumber' },
    { title: 'indCajaRetiro', property: 'retirementSaving' },
    { title: 'idEmpresa', property: 'workInformation.companyRef.companyID' },
    { title: 'nEmpresa', property: 'workInformation.companyRef.companyName' },
    { title: 'idContratoInterno', property: 'workInformation.contract.contractID' },
    { title: 'nContratoInterno', property: 'workInformation.contract.description' },
    { title: 'idCentroCosto', property: 'workInformation.costCenter.costCenterID' },
    { title: 'nCentroCosto', property: 'workInformation.costCenter.costCenterName' },
    { title: 'idDepartamento', property: 'workInformation.department.departmentID' },
    { title: 'nDepartamento', property: 'workInformation.department.departmentName' },
    { title: 'idCentroTrabajo', property: 'workInformation.workCenter.workCenterID' },
    { title: 'nCentroTrabajo', property: 'workInformation.workCenter.workCenterName' },
    { title: 'idTipoTrabajo', property: 'workInformation.wage.payrollType' },
    { title: 'idTipoSalario', property: 'workInformation.wage.wageID' },
    { title: 'nTipoSalario', property: 'workInformation.wage.wageName' },
    { title: 'sueldoCa', property: 'workInformation.wage.amount' },
    { title: 'salarioPromedio', property: 'workInformation.wage.averageSalary' },
    { title: 'fecAntigüedad', property: 'workInformation.seniorityDate' },
    { title: 'antigüedad', property: 'workInformation.seniorityYears' },
    { title: 'baja', property: 'workInformation.laidOff' },
    { title: 'idJefeInmediato', property: 'workInformation.supervisor.employeeNumber' },
    { title: 'direccionMailJefinm', property: 'workInformation.supervisor.email' },
    { title: 'nJefeInmediato', property: 'workInformation.supervisor.displayName' },
  ];

  employeeLiqHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'Nombres', property: 'firstName' },
    { title: 'Primer Apellido', property: 'firstLastName' },
    { title: 'Segundo Apellido', property: 'secondLastName' },
    { title: 'fecha-liq1', property: 'fecha-liq1' },
    { title: 'monto-liq1', property: 'monto-liq1' },
    { title: 'fecha-liq2', property: 'fecha-liq2' },
    { title: 'monto-liq2', property: 'monto-liq2' },
    { title: 'fecha-liq3', property: 'fecha-liq3' },
    { title: 'monto-liq3', property: 'monto-liq3' },
    { title: 'fecha-liq4', property: 'fecha-liq4' },
    { title: 'monto-liq4', property: 'monto-liq4' }
  ];

  employeeLoansHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeRef.employeeNumber' },
    { title: 'nombre', property: 'employeeRef.displayName' },
    { title: 'fechaConcesion', property: 'createdAt' },
    { title: 'fechaAprovacion', property: 'approvedAt' },
    { title: 'InicioSemanal', property: 'scheduleWeek' },
    { title: 'montoPrestamo', property: 'requestedAmount' },
    { title: 'montoInteres', property: 'interestAmount' },
    { title: 'totalCuotas', property: 'requestedNumberOfPayments' },
    { title: 'pagosRealizados', property: 'longPayments' },
    { title: 'montoPagado', property: 'sumPayments' },
    { title: 'tipo', property: 'type' },
    { title: 'estatus', property: 'status' },
  ];


  employeeLoansRendimientoHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'RendimientoGenerado', property: 'RendimientoGenerado' },
    { title: 'totalAhorrado', property: 'totalAhorrado' },
    { title: 'calSura', property: 'calSura' },
  ];

  employeesLoanListHeader: Array<any> = [
    { title: 'numero', property: 'listIndex' },
    { title: 'colaborador', property: 'employeeRef.employeeNumber' },
    { title: 'monto', property: 'requestedAmount' },
    { title: 'totalCuotas', property: 'requestedNumberOfPayments' },
    { title: 'porcentageInteres', property: 'interestPercentage' },
    { title: 'fechaAprobacion', property: 'approvedAtDate' },
    { title: 'fecha', property: 'createDate' },
    { title: 'tipo', property: 'type' },
    { title: 'loanID', property: 'loanID' },
  ];


  constructor(private dataService: DataSourceService, public snackBar: MatSnackBar, public ui: UiService, public logicService: LogicService) {
    this.ui.showSpinner();

    this.reportDate.startDate = moment().startOf('day').toDate();
    this.reportDate.endDate = moment().endOf('day').toDate();
    this.employeeNumber = '';
    
  }

  ngOnInit() {

    this.appModChangesSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe((response) => {
      if (response) {
        this.ui.stopSpinner();
        this.subCompanies = this.logicService.dataManager.generalDataLoader.companies;
      }
    });
    this.dataService.downloadLinkReportActiveLoans; 
    this.loanList();

  }

 async loanList(){
  const objectSavingParameters = await this.dataService.loadPermanentSavingsParameters(true).pipe(take(1)).toPromise().catch(error => {
    console.log(error);
    return [];
  });

  this.savingParameters = objectSavingParameters.filter(element => element.type == PeriodTypeEnum.permanentSaving);

 }

  selectedSubCompanyChange(event: MatSelectChange) {

    if (event.value) {
      this.tempSubCompany = event.value;
    } else {
      this.tempSubCompany = null;
    }

  }

  setStartDate(event: MatDatepickerInputEvent<moment.Moment>) {
    this.reportDate.startDate = event.value.startOf('day').toDate();
  }

  setEndDate(event: MatDatepickerInputEvent<moment.Moment>) {
    this.reportDate.endDate = event.value.endOf('day').toDate();
  }

  async collectionReportData(type: string, subTypes: Array<string> | null = null) {
    
    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();
    this.buildReportHeader(xlsx, type, subTypes, this.collectionByTypeHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }
        const dateCast = moment(doc.regDate).locale('es').format(this.format);
        doc.dateRegister = dateCast != 'Invalid date' ? dateCast : doc.regDate.toDate();
 
        this.buildReport(xlsx, this.collectionByTypeHeader, doc, row);
        row++;

      }

      return true;

    };

    
    if (this.tempSubCompany) {

      if (subTypes) {

        for (const subType of subTypes) {
          await this.dataService.loadContributionsByTypeSubTypeAndCompany(type, subType, this.tempSubCompany.companyID, this.employeeNumber, this.reportDate.startDate.getTime(), this.reportDate.endDate.getTime(), 5000, 15000).catch(error => console.log(error));
        }

      } else {

        await this.dataService.loadContributionsByTypeAndCompany(type, this.tempSubCompany.companyID, this.employeeNumber, this.reportDate.startDate.getTime(), this.reportDate.endDate.getTime(), 5000, 15000).catch(error => console.log(error));

      }

    } else {

      if (subTypes) {

        for (const subType of subTypes) {
          await this.dataService.loadContributionsByTypeAndSubType(type, subType, this.employeeNumber, this.reportDate.startDate.getTime(), this.reportDate.endDate.getTime(), 5000, 15000).catch(error => console.log(error));
        }

      } else {

        await this.dataService.loadContributionsByType(type, this.employeeNumber, this.reportDate.startDate.getTime(), this.reportDate.endDate.getTime(), 5000, 15000).catch(error => console.log(error));

      }

    }

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });


  }

  async collectionReporDR(type: string) {

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();
    this.buildReportHeader(xlsx, type, null, this.collectionByTypeHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }

        if((doc.investmentReturn || doc.loanPerformance )!= 0 && !doc.subType.includes("SURA")){

          const dateCast = moment(doc.regDate).locale('es').format(this.format);
          doc.dateRegister = dateCast != 'Invalid date' ? dateCast : doc.regDate.toDate();
  
          this.buildReport(xlsx, this.collectionByTypeHeader, doc, row);
          row++;

        }

      }

      return true;

    };

    await this.dataService.loadContributionsByType(type, this.employeeNumber, this.reportDate.startDate.getTime(), this.reportDate.endDate.getTime(), 5000, 15000).catch(error => console.log(error));


    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });


  }

  async collectionReportSura(type: string | null = null) {

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.collectionBySuraHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }

        this.buildReport(xlsx, this.collectionBySuraHeader, doc, row);
        row++;

      }

      return true;

    };


      await this.dataService.loadSuraByType(type, this.employeeNumber, this.reportDate.startDate.getTime(), this.reportDate.endDate.getTime(), 5000, 15000).catch(error => console.log(error));

    

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });


  }

/**  async collectionReportSura(type: string | null = null) {

    if (this.tempSubCompany !== null && this.tempSubCompany.companyID !== null) {

      this.ui.showSpinner();
      const xlsx = await XlsxPopulate.fromBlankAsync();

      this.buildReportHeader(xlsx, type, null, this.collectionBySuraHeader);
      let row = 5;

      this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

        for (const doc of batchResults) {
          let docSura: any;

          if (!doc) {
            continue;
          }
          let employeeNum: string = doc.uid;

          const sura = await this.dataService.loadSura(type, employeeNum);

          if (sura) {
            const dataSura = sura.docs.map(x => x.data());
            docSura = dataSura[0];
          }
          this.buildReport(xlsx, this.collectionBySuraHeader, docSura, row);
          row++;

        }

        return true;

      };
      await this.dataService.loadEmployeesByCompany('users', this.tempSubCompany.companyID, this.employeeNumber, 2000, 8000).catch(error => console.log(error));



      xlsx.outputAsync('blob').then(out => {
        this.ui.stopSpinner();
        saveAs(out, type + '-akiba.xlsx');
      }).catch((error: any) => {
        this.ui.stopSpinner();
        console.log('error', error);
      });

    } else {
      this.snackBar.open('Selecciona una compañia.', null, {
        duration: 3000,
        panelClass: ['green-snackbar']
      });
    }


  } */
  async collectionReportAportExt() {
    const type = 'Aport-Ext';
    const reportStart = moment("2020-01-01");
    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();
    const bonusTypes = [
      { id: "annualPerformance", name: "Bono Anual Por Desempeño", percentage: "annualPerformanceBonusPercentage", apply: false },
      { id: "profitSharing", name: "Reparto De Utilidades", percentage: "profitSharingPercentage", apply: true },
      { id: "target", name: "Bono Por Avance de Metas", percentage: "targetBonusPercentage", apply: false },
      { id: "yearEndAndPerformance", name: "Aguinaldo y Bono Anual Por Desempeño", percentage: "yearEndAndPerformanceBonusPercentage", apply: true },
      { id: "veabBonus", name: "Bono VEAB", percentage: "veabBonusPercentage", apply: false }
    ];

    this.buildReportHeader(xlsx, type, null, this.collectionByExtraHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {
        if (!doc) {
          continue;
        }
        
        if (doc.bonusPercentage.length > 0) {
          let employeeObj: any= {};
          employeeObj.employeeNumber = doc.employeeRef.employeeNumber;
          employeeObj.status = doc.status;
          const bonus = doc.bonusPercentage[0];

            for (const elem of bonusTypes) {
              if (bonus.bonus === elem.id) {
                employeeObj.bonusType = elem.name;
                employeeObj.permanentSavings = doc[elem.percentage];
              }
            }
            if ( bonus.type == 'capital'){
              employeeObj.type = 'disminución de importe';

            }else{
              employeeObj.type = 'disminución de pagos(tiempo)';
            }

            employeeObj.percentageLoan = bonus.percentage;
            employeeObj.date = typeof(bonus.date) == 'string' ? moment(bonus.date).toDate() : bonus.date.toDate();
            employeeObj.year = employeeObj.date.getFullYear();

        this.buildReport(xlsx, this.collectionByExtraHeader, employeeObj, row);
        row++;
      }
      }

      return true;

    };
      await this.dataService.loadActiveLoansAportExt(reportStart.toDate(), 5000, 15000).catch(error => console.log(error));

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });
  }

  async reportSavingShares() {
    const type = 'shareSavings';

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.collectionSavingsHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {
        if (!doc) {
          continue;
        }

        let employeeObj: any = {};
        const subscriptionDate: Date = doc.subscriptionDate.toDate();
        doc.employeeNumber = doc.user.employeeNumber;
        doc.contractNumber = doc.user.contractNumber;
        doc.userName = doc.user.userName;
        doc.investmentType = doc.user.investmentType;
        doc.subscriptionDate = subscriptionDate;

        this.buildReport(xlsx, this.collectionSavingsHeader, doc, row);
        row++;

      }

      return true;

    };
    await this.dataService.loadShareSavingsReport(type, 5000, 15000).catch(error => console.log(error));

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });
  }

  async loanRetirement() {
    const type = 'Prestamos-Ret';
    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.employeeLoansHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }

        const approvedAtDate: Date = doc.approvedAt.toDate();
        const createdAtDate: Date = doc.createdAt.toDate();
        const timeStamp = doc.createdAt.toDate();
        const to = new Date();

        let monto = 0;
        let long = 0;
        const loanTransactions = await this.dataService.loadEmployeeContributionsRetirement('LoanTransactions', doc.employeeRef.employeeNumber, timeStamp, to);
        let mappedArray = new Array<any>();
        let scheduleWeek : any;
        
        const scheduleDates = await this.dataService.loadLoanSchedulePayments(doc.loanID).pipe(take(1)).toPromise();

        if (scheduleDates) {
          const schedulePayments = scheduleDates.length > 0 ?  scheduleDates.map((rec: any) => rec.biWeekNumber) : Object.values(doc.scheduleDates).map((rec: any) => rec.biWeekNumber) ;
            doc.scheduleWeek = schedulePayments[0];
        }


          if (loanTransactions) {
            mappedArray = loanTransactions.docs.map(e => e.data()).filter(lt => lt.amortization > 0
              && (lt.loanType == 'CJRT' || lt.loanType == 'CJAR'));
          }
    

        let amortization: number = 0;
        let suma: number = 0;
        for (const payment of mappedArray) {
          if (payment.amortization === 1) {
            amortization += payment.amortization;
          } else {
            suma += payment.amortization;
          }
          long++;
        }

        monto = (suma / (long - amortization)) * long;

        doc.sumPayments = isNaN(monto) ? 0 : monto;
        doc.longPayments = long;
        doc.createdAt = createdAtDate;
        doc.approvedAt = approvedAtDate;

         // console.log(doc.employeeRef.employeeNumber + ' monto ' + monto + ' long ' + long);

          const loanData: any = {
            name: doc.employeeRef.displayName, employeeNumber: doc.employeeRef.employeeNumber,
            amount: doc.requestedAmount, interestAmount: doc.interestAmount, interestPercentage: doc.interestPercentage, interestType: doc.interestType,
            payments: doc.requestedNumberOfPayments, amountToDiscountPerPaymentCycle: doc.amountToDiscountPerPaymentCycle,
            week: doc.scheduleWeek,
            longPayments: doc.longPayments, sumPayments: doc.sumPayments, restructuredID: doc.restructuredID,
            approvedAt: approvedAtDate, created: createdAtDate, tipo: doc.type, status: doc.status
          };
     

        this.buildReport(xlsx, this.employeeLoansHeader, doc, row);
        row++;

      }

      return true;

    };
      await this.dataService.employeeLoansRetirement(5000, 15000).catch(error => console.log(error));


    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });
  }


  async employeeReport() {

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();
    const type = 'users';
    this.buildReportHeader(xlsx, 'Colaboradores', null, this.employeeHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }

        this.buildReport(xlsx, this.employeeHeader, doc, row);
        row++;

      }

      return true;

    };

    if (this.tempSubCompany) {

      await this.dataService.loadEmployeesByCompany(type, this.tempSubCompany.companyID, this.employeeNumber, 2000, 8000).catch(error => console.log(error));

    } else {

      await this.dataService.loadEmployees(type, this.employeeNumber, 2000, 8000).catch(error => console.log(error));

    }

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });

  }

  async liquidityReport() {

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();
    const type = 'users';
    this.buildReportHeader(xlsx, 'Colaboradores', null, this.employeeLiqHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {
        if (!doc) {
          continue;
        }
        const historicalObj = doc.workInformation && doc.workInformation.wage && doc.workInformation.wage.historical ? doc.workInformation.wage.historical : null;
        const employeeObj: any = { employeeNumber: doc.workInformation.employeeNumber, firstName: doc.firstName, firstLastName: doc.firstLastName, secondLastName: doc.secondLastName };
        if (historicalObj) {
          const keys = Object.keys(historicalObj);
          keys.forEach((e, index) => {
            const aHistory = historicalObj[e];
            const sIndex = Number(index + 1).toString();
            const fecha = 'fecha-liq' + sIndex;
            const monto = 'monto-liq' + sIndex;
            employeeObj[fecha] = aHistory.date;
            employeeObj[monto] = aHistory.amount;
          });
        }

        this.buildReport(xlsx, this.employeeLiqHeader, employeeObj, row);
        row++;

      }

      return true;

    };

    if (this.tempSubCompany) {

      await this.dataService.loadEmployeesByCompany(type, this.tempSubCompany.companyID, this.employeeNumber, 2000, 8000).catch(error => console.log(error));

    } else {

      await this.dataService.loadEmployees(type, this.employeeNumber, 2000, 8000).catch(error => console.log(error));

    }

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });

  }

  /**
   * asyncron function for facturation report
   */
  async BillingReport() {

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();
    const type = 'users';
    this.buildReportHeader(xlsx, 'Colaboradores', null, this.employeeLiqHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {
        if (!doc) {
          continue;
        }
        const historicalObj = doc.workInformation && doc.workInformation.wage && doc.workInformation.wage.historical ? doc.workInformation.wage.historical : null;
        const employeeObj: any = { employeeNumber: doc.workInformation.employeeNumber, firstName: doc.firstName, firstLastName: doc.firstLastName, secondLastName: doc.secondLastName };
        if (historicalObj) {
          const keys = Object.keys(historicalObj);
          keys.forEach((e, index) => {
            const aHistory = historicalObj[e];
            const sIndex = Number(index + 1).toString();
            const fecha = 'fecha-liq' + sIndex;
            const monto = 'monto-liq' + sIndex;
            employeeObj[fecha] = aHistory.date;
            employeeObj[monto] = aHistory.amount;
          });
        }

        this.buildReport(xlsx, this.employeeLiqHeader, employeeObj, row);
        row++;

      }

      return true;

    };

    if (this.tempSubCompany) {

      await this.dataService.billingByCompany(type, this.tempSubCompany.companyID, this.employeeNumber, 2000, 8000).catch(error => console.log(error));

    } else {

      await this.dataService.billing(type, this.employeeNumber, 2000, 8000).catch(error => console.log(error));

    }

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });

  }



  async buildLoanData(type: string) {
    let infoReport : any;
    
   if (this.tempSubCompany) {

  infoReport = await this.dataService.downloadLinkReport(type, this.tempSubCompany.companyID).pipe(take(1)).toPromise();

  }else{

  infoReport = await this.dataService.downloadLinkReport(type, '').pipe(take(1)).toPromise();

  }
      

      console.log('url', infoReport);

      if (infoReport && infoReport.url !== '') {
        let url: string = infoReport.url;
        window.open(url, "_blank");

      } else {
        this.snackBar.open('El archivo esta en construcción, intentar mas tarde.', null, {
          duration: 2300,
          panelClass: ['green-snackbar']
        });
      }

  /*  } else {
      this.snackBar.open('Seleccione una compañia para la descarga del reporte.', null, {
        duration: 2300,
        panelClass: ['green-snackbar']
      });

    }*/

  }

  /**hago los reportes de miriam de CAL totales */
  async reportRendimiento() {
    let _suraAmount: number = 0;
    let returns: number = 0;

    returns
    let type = 'CAL';

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.employeeLoansRendimientoHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        let totalA = 0;
  
        let totalWithdraw = 0;
        let totalCompanyAmount = 0;
        let investmentReturn = 0;
        let totalWithdrawAL = 0;
        let loanPerformance = 0;

        if (!doc) {
          continue;
        }
        const calSura =  await this.dataService.loadSura('CAL_SURA', doc.employeeNumber);
        const loanCal = await this.dataService.loadRetirement('CAL', doc.employeeNumber).pipe(take(1)).toPromise();        

        if (calSura){
           const sura = calSura.docs.map(x => x.data());
           _suraAmount = sura.map(x => x.amount).reduce((p, n) => p + n, 0);    
        }

        let contributionArrayF: Array<Contribution> = loanCal.map((rec: any) => new Contribution(rec)).
          filter(e => e.subType === 'CAL_DR' || e.subType === 'CAL_DRE');
          // Todos los cal ['CAL_AL','CAL_C','CAL_CE','CAL_CL','CAL_N','CAL_NE','CAL_RL','CAL_R', CAL_RE'] 
          const totalN = loanCal.map((rec: any) => new Contribution(rec)).
          filter(e => e.subType != 'CAL_DR' && e.subType != 'CAL_DRE');
          const minus1: Array<Contribution> = loanCal.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_N')).filter(e => e.investmentReturn < 0 || e.loanPerformance < 0);
          const minus2: Array<Contribution> = loanCal.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_AL') || e.subType.includes('_RL')  || e.subType.includes('_R')).filter(e => e.employeeSettlement >= 0);
          const minus: Array<Contribution> = loanCal.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_CL') || e.subType.includes('_C')).filter(e => e.employeeSettlement >= 0);
         
          const t = minus.map(r => Math.abs(r.employeeSettlement) + Math.abs(r.investmentReturn) + Math.abs(r.loanPerformance)).reduce((p, n) => p + n, 0);
          const t1 = minus1.map(r => Math.abs(r.investmentReturn) + Math.abs(r.loanPerformance)).reduce((p, n) => p + n, 0);
          const t2 = minus2.map(r => Math.abs(r.employeeSettlement) + Math.abs(r.investmentReturn) + Math.abs(r.loanPerformance) ).reduce((p, n) => p + n, t1);

      totalN.forEach(element => {
        
        let loanPerf = element.loanPerformance  && element.loanPerformance !== undefined && element.loanPerformance > 0 ? element.loanPerformance : 0;
        totalA += element.employeeAmount;
        totalCompanyAmount += element.companyAmount;
        totalWithdraw += element.employeeWithdraw;
        investmentReturn += element.investmentReturn;
        loanPerformance += loanPerf;
    });


        /**terminan totales, por optimizar  */

        let temp = 0;
        const result = contributionArrayF.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
        returns = result + t - t2 ;
        const totalAhorrado = totalA + totalCompanyAmount - totalWithdraw;

        const t3 = {
          text: 'Rendimiento Generado',
          total: returns <= 0 ? 0 : returns.toFixed(3) 
      };

      const t4 = {
          text: 'totalAhorrado',
          total: totalAhorrado <= 0 ? 0 : totalAhorrado.toFixed(3) 
      };

        let dataRes : any = {
          employeeNumber: doc.employeeNumber, RendimientoGenerado: t3.total  , 
          totalAhorrado: t4.total  , calSura: _suraAmount,
      }; 

      console.log('dataRes', dataRes);
        this.buildReport(xlsx, this.employeeLoansRendimientoHeader, dataRes, row);
        row++;

      }

      return true;

    };

    
    if (this.tempSubCompany) {
      await this.dataService.calAccumulated(this.tempSubCompany.companyID, 2000, 8000).catch(error => console.log(error));

    } else {

      await this.dataService.calAccumulated('',  2000, 8000).catch(error => console.log(error));

    }
  
    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });


  }

  async collectionReportLoansList(periodID: string,periodType: string, savingAccount: boolean) {
    let _suraAmount: number = 0;
    let type = 'employeesLoanList';
    let name = ''; 
    if(savingAccount === true){
      name = 'presamosAhorrador'+ periodType;
    }else{
      name = 'prestamosNoAhorrador'+ periodType;
    }

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, name, null, this.employeesLoanListHeader);
    let row = 5;

    this.dataService.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }
        
      doc.interestPercentage = doc.interestPercentage ? doc.interestPercentage * 100 : 0;
      doc.approvedAtDate = doc.approvedAt;
      doc.createDate = doc.createdAt;

        this.buildReport(xlsx, this.employeesLoanListHeader, doc, row);
        row++;

      }

      return true;

    };

    await this.dataService.loadEmployeeLoanListReporte( periodID, savingAccount , 5000, 15000).catch(error => console.log(error));

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, name + '.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });
  }

  buildReportHeader(xlsxRef: any, type: string, subTypes: Array<string> | null, headers: Array<any>) {

    const fStart = moment(this.reportDate.startDate).locale('es').format(this.format);
    const fEnd = moment(this.reportDate.endDate).locale('es').format(this.format);

    xlsxRef.sheet(0).row(1).cell(2).value(fStart);
    xlsxRef.sheet(0).row(2).cell(2).value(fEnd);

    let title = type;
    if (subTypes) {
      title = subTypes.join(' / ');
    }

    xlsxRef.sheet(0).row(3).cell(1).value(title);

    const headerRef = xlsxRef.sheet(0).row(4);
    let headerCellIndex = 1;
    for (const header of headers) {
      const cell = headerRef.cell(headerCellIndex);
      this.buildCell(cell, header.title);
      headerCellIndex++;
    }

  }

  buildReport(xlsxRef: any, headers: Array<any>, data: any, row: number) {

    const rowRef = xlsxRef.sheet(0).row(row);

    let cellIndex = 1;
    for (const header of headers) {
      const cell = rowRef.cell(cellIndex);
      this.buildCell(cell, header.property, data);
      cellIndex++;
    }

  }


  buildCell(cell: XlsxPopulate.Cell, property: string, data: any = null) {

    if (data) {
      const properties = property.split('.');
      const value = this.searchPropertyValue(properties, data);

      if (!Helpers.isObject(value)) {

        cell.value(value);

      } else {

        try {

          if (Helpers.isDate(value)) {
            const aDate = moment(value).locale('es').format(this.format);
            cell.value(aDate);
          } else if (typeof value.toDate === 'function') {

            const time = moment.unix(value.seconds).utc(true);
            const year = time.year();
            const month = time.month();
            const day = time.date();
            const newD = new Date(year, month, day);
            const aDate = moment(newD).locale('es').format(this.format);
            cell.value(aDate);

          } else {
            cell.value('-');
          }

        } catch (error) {
          cell.value('-');
        }

      }

    } else {
      cell.value(property);
    }

  }

  searchPropertyValue(propertyNames: Array<string>, object: any): any {

    if (propertyNames.length) {

      const pName = propertyNames.splice(0, 1)[0].trim();

      if (object.hasOwnProperty(pName)) {
        const childObject = object[pName];
        return this.searchPropertyValue(propertyNames, childObject);
      }

    }

    return object;

  }

  ngOnDestroy(): void {
    if (this.appModChangesSubscription && !this.appModChangesSubscription.closed) {
      this.appModChangesSubscription.unsubscribe();
      this.appModChangesSubscription = null;
    }
  }

}
